var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'ThemeGroupbuyingList'
      }
    }
  }, [_vm._v("主題團購管理")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("新增主題團購")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row mb-2 align-items-center"
  }, [_c('div', {
    staticClass: "col-12 col-xl-2"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("新增主題團購")])])]), _c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('theme-groupbuying-form', {
    ref: "form",
    attrs: {
      "form": _vm.form,
      "start-at": _vm.startAt,
      "end-at": _vm.endAt,
      "img-file": _vm.imgFile,
      "validation-errors": _vm.validationErrors,
      "form-mode": "create"
    },
    on: {
      "update:imgFile": function updateImgFile($event) {
        _vm.imgFile = $event;
      },
      "update:img-file": function updateImgFile($event) {
        _vm.imgFile = $event;
      }
    }
  }), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'ThemeGroupbuyingList'
        });
      }
    }
  }, [_vm._v("返回")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("儲存")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }